export const LANGUAGE_PROFICIENCY = {
  BEGINNER: "BEGINNER",
  ELEMENTARY: "ELEMENTARY",
  INTERMEDIATE: "INTERMEDIATE",
  UPPER_INTERMEDIATE: "UPPER_INTERMEDIATE",
  ADVANCED: "ADVANCED",
  NATIVE: "NATIVE"
};

export const LanguageProficiencyConstants = {
  [LANGUAGE_PROFICIENCY.BEGINNER]: {
    code: "BEGINNER",
    badge: "keduall-badge keduall-badge-normal-success"
  },
  [LANGUAGE_PROFICIENCY.ELEMENTARY]: {
    code: "ELEMENTARY",
    badge: "keduall-tag elementary-tag"
  },
  [LANGUAGE_PROFICIENCY.INTERMEDIATE]: {
    label: "INTERMEDIATE",
    badge: "keduall-tag intermediate-tag"
  },
  [LANGUAGE_PROFICIENCY.UPPER_INTERMEDIATE]: {
    label: "UPPER_INTERMEDIATE",
    badge: "keduall-badge keduall-badge-normal-primary"
  },
  [LANGUAGE_PROFICIENCY.ADVANCED]: {
    label: "ADVANCED",
    badge: "keduall-tag advanced-tag"
  },
  [LANGUAGE_PROFICIENCY.NATIVE]: {
    label: "NATIVE",
    badge: "keduall-tag native-tag"
  }
};